import { EEntityType, IEntityInfo } from '../types';
import { getFullLayoutInfo } from './layout/detect';
import { startFullLayout, startPartialLayout } from './layout/mode';
import { toastNoDoorInRoom } from '@/editor/controller/controller2d/operateLayout/utils';

export function startLayoutGenerate(info?: IEntityInfo) {
  const { entityId, type } = info ?? {};
  if (!entityId || !type) {
    return;
  }

  switch (type) {
    case EEntityType.Room:
      if (!getFullLayoutInfo(entityId, true)) {
        toastNoDoorInRoom();
      } else {
        startFullLayout(entityId);
      }
      break;
    case EEntityType.Region: {
      startPartialLayout(entityId);
      break;
    }
  }
}
